import { all } from 'ramda';

export class Interface {
  spec: any;

  constructor(spec: any) {
    this.spec = spec;

    if (!this.spec || !this.spec.length) {
      throw new Error('Could not create Interface');
    }
  }

  check(obj: any) {
    if (!obj) {
      return false;
    }

    function functionPresent(key: string) {
      return obj[key] && typeof obj[key] === 'function';
    }
    return all(functionPresent, this.spec);
  }
}
